import React from "react";
import axios from "axios";

const token =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOjQ0MTI1MCwiaXNwIjoxNzI5MjM1NTU4LCJleHAiOjE3MzA1MzE1NTgsImlhdCI6MTcyOTIzNTU1OH0.govYrCothoB4sZxd-TBQ0G4QD4PUmf2HolHKZPnQ_TUB81xtnPaZ5NVIOtsgHCKh01QIcYUlA8ZocXMGlUg0RWZVLfEYrPia3tzlXOKF3v4IhmhcNnhUERmgII7P6OpZu3-Ve-m5wSZiRKPoIzkdALsdoSAErB_tXAHSnuLmU-AC1OHxzogqz-_-yRB8sXHSoS9h-CJXNWmftUSm1oxNkdb7HogjSe5uodjMPp0qAgcGEJyk7z1Z7sYolCEGVZ1NP0TX0vKyT3RwDlhHVljo6q60-q1SNlcDWszdPPc28yBs6QBOpaStIBYhpli0emaiy2zUs9oyF4MkfTDI2zNWbw";

export default function RozarPayPayment() {
  const handlePayment = async () => {
    try {
      const res = await axios({
        url: "https://dev.ramfincorp.co.in/new-api/customer_onboarding/set-emandateV2",
        method: "post",
        data: {
          accountId: 43549,
          leadID: 447581,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res?.data) {
        handleNewPayment(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // callback_url: "http://localhost:3000/rozarpay-payment-status",

  const handleNewPayment = async (data) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const options = {
        key: "rzp_test_VOS5JBBAcTK4Yp", // Replace with your Razorpay Key ID
        customer_id: data.data.customer_id,
        order_id: data.data.order_id,
        recurring: 1,
        callback_url: `https://dev.ramfincorp.co.in/new-api/customer_onboarding/fetch-emandate-invoice?callBack=https://demorf.ramfincorp.co.in/emandate`,
        notes: {
          disableWebhook: true,
        },
        theme: {
          color: "#F37254",
        },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open(); // Open Razorpay payment gateway
    };
  };

  return (
    <div>
      <p>RozarPayPayment</p>

      <button onClick={() => handlePayment()}>Pay Now</button>
    </div>
  );
}
